export const sendEmail = (email: string, id: string): void => {
  window.location.href = `mailto:${email}&subject=Ответ на обращение №${id}`;
};
